<template>
    <ConfirmationModal
        title="You have unsaved changes"
        yes="Return to page"
        no="Discard changes"
        additional-class-name="UnsavedChangesModal"
        v-bind="$attrs"
    >
        You have unsaved changes that will be lost if you leave this page. Do you want to return to the page to save them?
    </ConfirmationModal>
</template>

<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import ConfirmationModal from '@/components/confirmation-modal/ConfirmationModal.vue';

    @Component({
        components: {
            ConfirmationModal,
        },
    })
    export default class UnsavedChangesModal extends Vue {
    }
</script>
